export const queryParams = (obj) => {
    let params = '';
    for (var key in obj) {
        const item = obj[key];
        if (item) {
            params = params
                ? `${params}&${key}=${item}`
                : `${key}=${item}`;
        }
    }
    return params;
};

export const titleCase = (name) => {
    const nameParts = name.split(' ');
    let titleCase = '';
    for (let i = 0; i < nameParts.length; i++) {
        titleCase += (i > 0 ? ' ' : '') + nameParts[i].substr(0, 1).toUpperCase() + nameParts[i].substr(1).toLowerCase();
    }
    return titleCase;
};


export const getInitial = (name) => {
    if (name !== null && name.length > 0) {
        return name[0].toUpperCase();
    }
    else {
        return name;
    }
};


export const reduceSpaces = (someString) => {
    if (someString !== null) {
        while (someString.indexOf('  ') > -1) {
            someString = someString.replace('  ', ' ');
        }
    }
    return someString;
};


export const getInitials = (diplayName) => {
    let name = reduceSpaces(diplayName).trim();
    let firstInitial = '', lastInitial = '';
    if (name.indexOf(',') > -1) {
        let parts = name.split(',');
        firstInitial = getInitial(parts[1].trim());
        lastInitial = getInitial(parts[0].trim());
    }
    else {
        let parts = name.split(' ');
        firstInitial = getInitial(parts[0].trim());
        if (parts.length > 1) {
            lastInitial = getInitial(parts[1].trim());
        }
    }
    return firstInitial + lastInitial;
};



export const getFirstName = (diplayName) => {
    let name = diplayName.trim();
    if (name.indexOf(',') > -1) {
        let first = name.split(',')[1];
        return first.trim().split(' ')[0];
    }
    else {
        return name.split(' ')[0];
    }
};

export const getSecondName = (diplayName) => {
    let name = diplayName.trim();
    if (name.indexOf(',') > -1) {
        let second = name.split(',')[0];
        return second.trim();
    }
    else if (name.indexOf(' ') > -1){
        return name.split(' ')[1];
    }
    return null;
};

export const firstNameFirst = (diplayName) => {
    let name = diplayName.trim();
    const commaIndex = name.indexOf(',');
    if (commaIndex > -1) {
        const last = name.substr(0, commaIndex).trim();
        const first = name.substr(commaIndex + 1).trim();
        return titleCase(first + ' ' + last);
    }
    else {
        return titleCase(name);
    }
};

export const formatDoctorName = (displayName) => {
    let fullName = '';
    if (displayName) {
        let displayNameArr = displayName.split(',');
        if (displayNameArr.length > 2) {
            fullName = displayNameArr[1] +' '+ displayNameArr[0] +','+ displayNameArr[2];
        } else if (displayNameArr.length > 1) {
            fullName = displayNameArr[1] +' '+ displayNameArr[0];
        } else if (displayNameArr.length > 0){
            fullName = displayNameArr[0]
        }
    }
    return fullName;
};

export const formatPhoneNumber = (phone) => {
    const cleaned = ('' + phone).replace(/\D/g, '');
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
        return match[1] + '.' + match[2] + '.' + match[3];
    }
    return null;
};

export const formatPrice = (amount) => {
    if (amount) {
        const formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
        let price = (typeof amount === 'number') ? amount : parseFloat(amount);

        return formatter.format(price);
    } else {
        return amount;
    }

};

export const rxRoute = (routeName) => {
    let prefix = '/';
    if (typeof window !== 'undefined' && window.serverData.data.bundle !== 'pharmacy' &&
        window.location.href.toLowerCase().indexOf('localhost') > -1) {
        prefix = '/pharmacy';
    }
    if (routeName && routeName[0] === '/') {
        routeName = routeName.substr(1);
    }
    return prefix + routeName;
};

const rxPath = /\brxlist|\brxrefill|\brxtransfer|\bbswtransfer|\bnonbswtransfer|\bfindpharmacy|\brxhome/;

export const isRxRoute = (pathname) => {
    const prefix = '/pharmacy';
    let pathToCheck = pathname.toLowerCase();
    if (typeof window !== 'undefined' && window.location.href.toLowerCase().indexOf('localhost') > -1 &&
        pathToCheck.indexOf(prefix) === 0) {
        pathToCheck = pathToCheck.substr(prefix.length);
    }
    return rxPath.test(pathToCheck);
};

export const replaceURLs = (message) => {
    if (!message) return;

    const urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
    return message.replace(urlRegex, function (url) {
        let hyperlink = url;
        if (!hyperlink.match('^https?:\/\/')) {
            hyperlink = 'http://' + hyperlink;
        }
        return '<a href="' + hyperlink + '" target="_blank">' + url + '</a>'
    });
}

export const replacePhoneNumber = (message) => {
    if (!message) return;

    const urlRegex = /(?:[-+() ]*\d){10,13}/gm;
    return message.replace(urlRegex, function (number) {
        
        return '<a href="tel:'+ number +'">' + number + '</a>'
    });
}

export const numIntoWords = (number) => {
    const first = ['', 'one ', 'two ', 'three ', 'four ', 'five ', 'six ', 'seven ', 'eight ', 'nine ', 'ten ', 'eleven ', 'twelve ', 'thirteen ', 'fourteen ', 'fifteen ', 'sixteen ', 'seventeen ', 'eighteen ', 'nineteen '];
    const tens = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];
    const mad = ['', 'thousand', 'million', 'billion', 'trillion'];
    let word = '';

    for (let i = 0; i < mad.length; i++) {
        let tempNumber = number % (100 * Math.pow(1000, i));
        if (Math.floor(tempNumber / Math.pow(1000, i)) !== 0) {
            if (Math.floor(tempNumber / Math.pow(1000, i)) < 20) {
                word = first[Math.floor(tempNumber / Math.pow(1000, i))] + mad[i] + ' ' + word;
            } else {
                word = tens[Math.floor(tempNumber / (10 * Math.pow(1000, i)))] + '-' + first[Math.floor(tempNumber / Math.pow(1000, i)) % 10] + mad[i] + ' ' + word;
            }
        }

        tempNumber = number % (Math.pow(1000, i + 1));
        if (Math.floor(tempNumber / (100 * Math.pow(1000, i))) !== 0) word = first[Math.floor(tempNumber / (100 * Math.pow(1000, i)))] + 'hunderd ' + word;
    }
    return word;
}